const BUILD = process.env.VUE_APP_BUILD; // Definida no deploy pelo Forge
const LAST_BUILD = localStorage.getItem('app_build_version');

async function clearCacheAndCookies() {
  // 1) Apagar cookies não-HttpOnly
  const deleteCookie = (name, domain, path = '/') => {
    const d = domain ? `;domain=${domain}` : '';
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}${d}`;
  };

  const cookiePairs = document.cookie.split(';').map(c => c.trim()).filter(Boolean);
  const cookieNames = cookiePairs.map(p => p.split('=')[0]);

  const domains = [
    window.location.hostname,                              // ex: app.example.com
    '.' + window.location.hostname.replace(/^[^.]+/, ''),  // ex: .example.com
  ];
  const paths = ['/', location.pathname.split('/')[1] ? `/${location.pathname.split('/')[1]}` : '/'];

  for (const name of cookieNames) {
    for (const domain of domains) {
      for (const path of paths) {
        deleteCookie(name, domain, path);
      }
    }
  }

  // 2) Apagar caches (PWA / Cache API)
  if ('caches' in window) {
    const keys = await caches.keys();
    await Promise.all(keys.map(k => caches.delete(k)));
  }

  // 3) Desativar service worker antigo (se existir)
  if ('serviceWorker' in navigator) {
    const regs = await navigator.serviceWorker.getRegistrations();
    for (let reg of regs) {
      await reg.unregister();
    }
  }
}

export default async function cleanCacheOnNewBuild() {
  if (LAST_BUILD && LAST_BUILD !== BUILD) {
    await clearCacheAndCookies();
    console.log(`Cache e cookies limpos — nova versão: ${BUILD}`);
    // Opcional: recarregar a página automaticamente
    // window.location.reload(true);
  }
  localStorage.setItem('app_build_version', BUILD);
}
